import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, ButtonGroup, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import ProjectMonitorRecordTable from './ProjectMonitorRecordTable'
import ProjectMonitorRecordForm from './ProjectMonitorRecordForm'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  saveManageBankAccount,
  deleteManageBankAccount,
  getManageBankAccount,
  editManageBankAccount,
} from '../../redux/actions/manageBankAccount'
import notification from '../../utils/notification'
import PerformanceResultsWidget from '../progressReportSubprojectWidget/PerformanceResultsWidget'
import ProgressReportWidget from '../progressReportSubprojectWidget/ProgressReportWidget'
import OutcomesWidget from '../progressReportSubprojectWidget/OutcomesWidget'

export default function ProjectMonitorRecordWidgets(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [voucherSchema, setVoucherSchema] = useState()
  const [dataTable, setDataTable] = useState(props.schema.formTable)
  const [formDisplayLists, setFormDisplayLists] = useState()
  const [isExpanded, setIsExpanded] = useState(true)
  const [selectRowData, setSelectRowData] = useState()
  const [isExpandedForm, setIsExpandedForm] = useState(true)
  const [isAddBankAccount, setIsAddBankAccount] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const projectCode = sessionStorage.getItem('projectCode')
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const history = useHistory()
  console.log('1111111==> ', formSchema)

  useEffect(() => {
    setIsExpanded(false)
  }, [])

  const handleGetSchemaEdit = async (id) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await editManageBankAccount(id)
      setSelectRowData(response.model)
      // console.log('responseEdit', response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleSelectRowData = async (rowData) => {
    // console.log('handleSelectRowData ', rowData)
    // setSelectRowData(rowData)
    setIsAddBankAccount(false)
    setIsExpanded(false)
    handleGetSchemaEdit(rowData.id)
  }

  const handleAddBankAccount = () => {
    clearErrors()
    setIsAddBankAccount(true)
    setIsExpanded(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    // console.log('selectRowData', selectRowData)
    let request = {
      id: selectRowData?.id ? selectRowData.id : null,
      projectCode: projectCode,
      bankName: data.bankName,
      accountName: data.accountName,
      accountNo: data.accountNo,
      accountType: data.accountType,
      bankBranch: data.bankBranch,
    }
    // setIsShowConfirm(true)
    handleCallService(request)
  }

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)

    try {
      let response = await saveManageBankAccount(request)
      if (response) {
        // clearValues()

        setIsExpanded(true)
        setIsAddBankAccount(false)
        setSelectRowData()
        setFormSchema(response.model)
        // console.log('responseTest', response)
      } else {
        // setIsError('ไม่สำเร็จ')
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      notification.open('error', {
        title: e.response.data.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnReload = async (projectCode) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getManageBankAccount(projectCode)
      // console.log('reload response', response)
      if (response) {
        // setSchema(response)
        setFormSchema(response.model)
      }
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnDelete = async (rowData) => {
    startLoading()
    setIsLoading(true)
    // setIsError(false)
    try {
      const response = await deleteManageBankAccount(rowData.id)
      // console.log('fff', response)
      if (response == 200) {
        handleOnReload(projectCode)
      } else {
        alert('test')
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.statusText || 'ลบไม่สำเร็จ',
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const clearValues = () => {
    setValue(formSchema.bankName.name, '')
    setValue(formSchema.accountName.name, '')
    setValue(formSchema.accountNo.name, '')
    setValue(formSchema.accountType.name, '')
  }

  return (
    <>
      {/* ผลการดำเนินงาน */}
      {formSchema.form.performanceResults && (
        <>
          <PerformanceResultsWidget
            schema={formSchema.form.performanceResults}
            isReadOnly={formSchema.isReadOnly}
          />
          <br />
        </>
      )}

      {/* ความก้าวหน้า */}
      {formSchema.form.progress && (
        <>
          <ProgressReportWidget
            schema={formSchema.form.progress}
            isReadOnly={formSchema.isReadOnly}
          />
          <br />
        </>
      )}
      {/* ผลลัพธ์อื่นๆ */}
      {formSchema.form.otherOutcomes && (
        <>
          <OutcomesWidget
            schema={formSchema.form.otherOutcomes}
            isRole={formSchema.isRole}
            isReadOnly={formSchema.isReadOnly}
          />
          <br />
        </>
      )}

      <Panel
        shaded
        collapsible
        defaultExpanded
        header={'บันทึกการติดตาม'}
        bordered
        // expanded={isExpandedForm}
        // onSelect={() => {
        //   setIsExpandedForm(!isExpandedForm)
        // }}
      >
        <ProjectMonitorRecordForm
          schema={formSchema?.form?.formInput}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          getValues={getValues}
          setValue={setValue}
          clearErrors={clearErrors}
          rowData={selectRowData}
          // isAddBankAccount={isAddBankAccount}
        />

        <hr />
        {isError && <Message showIcon type="error" description={isError} />}
        <Row>
          <Col style={{ textAlign: 'end' }}>
            <SaveButton onClick={handleSubmit(onSubmit)}>{'บันทึก'}</SaveButton>
            {/* <SaveButton onClick={handleSubmit(onSubmit)}>{'แจ้งผลติดตาม'}</SaveButton> */}

            {/* <CancelButton
              onClick={() => {
                setIsExpanded(true)
                setIsAddBankAccount(false)
                setSelectRowData()
                clearErrors()
              }}
            >
              ยกเลิก
            </CancelButton> */}
          </Col>
        </Row>
      </Panel>
      <br />
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={'ประวัติการติดตามโครงการ'}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
      >
        <ProjectMonitorRecordTable
          schema={formSchema}
          data={formSchema?.form?.data}
          loading={isLoading}
          onSelect={handleSelectRowData}
          onDelete={handleOnDelete}
          isViewMode={formSchema?.disabled}
        />
      </Panel>
    </>
  )
}
